import React from 'react';

interface ProgressPieProps {
	percentage: number | undefined;
	size?: number;
	strokeWidth?: number;
	backgroundColor?: string;
	progressColor?: string;
	className?: string;
}

export const ProgressPie: React.FC<ProgressPieProps> = ({
	percentage = 0,
	size = 64,
	strokeWidth = 8,
	backgroundColor = 'rgba(0, 120, 208,0.1)',
	progressColor = '#0078d0',
	className = ''
}) => {
	// Ensure percentage is between 0 and 100
	const normalizedPercentage = Math.min(100, Math.max(0, percentage));

	// Calculate dimensions
	const radius = (size - strokeWidth) / 2;
	const circumference = 2 * Math.PI * radius;
	const strokeDashoffset = circumference - (normalizedPercentage / 100) * circumference;

	const styles = {
		container: {
			width: size,
			height: size,
			backgroundColor: backgroundColor
		}
	};

	return (
		<div style={styles.container} className="progress-pie">
			<svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
				{/* Background circle */}
				<circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="transparent" strokeWidth={strokeWidth} />

				{/* Progress circle */}
				<circle
					cx={size / 2}
					cy={size / 2}
					r={radius}
					fill="none"
					stroke={progressColor}
					strokeWidth={strokeWidth}
					strokeDasharray={circumference}
					strokeDashoffset={strokeDashoffset}
					strokeLinecap="round"
					style={{
						transition: 'stroke-dashoffset 0.3s ease'
					}}
				/>
			</svg>

			<span className="progress-text">
				<strong>{Math.round(normalizedPercentage)}%</strong>
			</span>
		</div>
	);
};

export default ProgressPie;
